<script setup>
import { ref, computed } from "vue";

const DEFAULT_ICON_URL = "/images/site/default-photo.svg";

const props = defineProps({
  packageEvent: {
    type: Object,
    required: true,
  },
});

const imageUrl = computed(() => props.packageEvent?.participants?.team?.homeTeam?.imageUrl)
</script>

<template>
  <div class="i-package-event-name">
    <div class="i-package-event-name__img">
      <img :src="imageUrl || DEFAULT_ICON_URL" alt="Домашняя команда">
    </div>
    <div class="i-package-event-name__wrapper">
      <div class="i-package-event-name__title">
        {{ packageEvent.name }}
      </div>
      <div class="i-package-event-name__nom-name">
        {{ packageEvent.nomName }}
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.i-package-event-name {
  display: flex;
  gap: 12px;
  color: $color;

  &__img {
    width: 50px;
    height: 50px;
    min-width: 50px;
    min-height: 50px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 4px;
  }

  &__title {
    font-size: 18px;
    font-weight: 700;
  }

  &__nom-name {
    font-size: 14px;
    color: $gray-medium;
  }
}
</style>
